function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import FlightResultsProvider from './providers/FlightResultsProvider';
import { useItineraryFromUrl } from '@edreamsodigeo/frontend-checkout';
import { Page as ResultsPage } from './pages/results';
import { Page as FiltersPage } from './pages/filters';
import { Page as CheckoutFlightSummaryResultsPage } from './pages/checkout_flight_summary_results';
import { Page as CheckoutFlightSummaryMetaPage } from './pages/checkout_flight_summary_meta';
import { ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
const FlightResultsWrapper = ({
  flightResultsProviderProps,
  children
}) => {
  const itineraryFromUrl = useItineraryFromUrl();
  return /*#__PURE__*/React.createElement(FlightResultsProvider, _extends({
    itineraryFromUrl: itineraryFromUrl
  }, flightResultsProviderProps), children);
};
FlightResultsWrapper.propTypes = {
  flightResultsProviderProps: PropTypes.object,
  children: PropTypes.node.isRequired
};
export const FlightsResultsFunnel = flightResultsProviderProps => {
  return /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: "shell_funnel_flights_results"
  }, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
    name: "funnel_flights_results"
  }, /*#__PURE__*/React.createElement(FlightResultsWrapper, {
    flightResultsProviderProps: flightResultsProviderProps
  }, /*#__PURE__*/React.createElement(ResultsPage, null), /*#__PURE__*/React.createElement(FiltersPage, null), /*#__PURE__*/React.createElement(CheckoutFlightSummaryResultsPage, null), /*#__PURE__*/React.createElement(CheckoutFlightSummaryMetaPage, null))));
};